module.exports = __webpack_public_path__ + "static/media/21_A.c69e0bac.png";